function getTokenInput(form) {
	let input = form.querySelector('input[name="smart-token"]');

	if (!input) {
		input = document.createElement('input');
		input.type = 'hidden';
		input.name = 'smart-token';
		form.appendChild(input);
	}

	return input;
}

function executeCaptcha(element) {
	if (!window.smartCaptcha || !element.dataset.widgetId) {
		element.dataset.executeWhenReady = 'true';
		init(element.closest('form'));
		return;
	}

	delete element.dataset.executeWhenReady;
	window.smartCaptcha.execute(Number(element.dataset.widgetId));
}

function resumeForm(element, token) {
	const form = element.closest('form');

	delete element.dataset.executing;

	if (!form || !token) {
		return;
	}

	getTokenInput(form).value = token;
	form.dataset.smartCaptchaVerified = 'true';

	const submitter = form._smartCaptchaSubmitter;

	if (typeof form.requestSubmit === 'function') {
		if (submitter && form.contains(submitter)) {
			form.requestSubmit(submitter);
		} else {
			form.requestSubmit();
		}
	} else {
		$(form).trigger('submit');
	}
}

function onloadYandexCaptcha(items) {
	if (!window.smartCaptcha) {
		return;
	}

	items = items || document.querySelectorAll('.smart-captcha');
	items.forEach((element) => {
		if (element.dataset.widgetId) {
			return;
		}

		const widgetId = window.smartCaptcha.render(element, {
			sitekey: element.dataset.sitekey,
			hl: 'ru',
			invisible: true,
			callback: (token) => resumeForm(element, token),
		});

		element.dataset.widgetId = widgetId;

		if (element.dataset.executeWhenReady === 'true') {
			executeCaptcha(element);
		}
	});
}

function init(container = null) {
	container = container || document;

	const items = container.querySelectorAll('.smart-captcha');

	if (!items.length) {
		return;
	}

	const existingScript = document.getElementById('smartcaptcha');

	if (existingScript) {
		if (window.smartCaptcha) {
			onloadYandexCaptcha(items);
		} else {
			existingScript.addEventListener('load', () => onloadYandexCaptcha(items), {once: true});
		}

		return;
	}

	const script = document.createElement('script');

	script.setAttribute('src', 'https://smartcaptcha.yandexcloud.net/captcha.js');
	script.setAttribute('id', 'smartcaptcha');
	script.async = true;
	script.defer = true;
	script.onload = () => onloadYandexCaptcha(items);

	document.head.appendChild(script);
}

function resetCaptcha(form) {
	delete form.dataset.smartCaptchaVerified;
	getTokenInput(form).value = '';

	form.querySelectorAll('.smart-captcha[data-widget-id]').forEach((element) => {
		delete element.dataset.executing;
		delete element.dataset.executeWhenReady;

		if (window.smartCaptcha) {
			window.smartCaptcha.reset(Number(element.dataset.widgetId));
		}
	});
}

document.addEventListener('submit', (event) => {
	const form = event.target;
	const captcha = form.querySelector('.smart-captcha');

	if (!captcha || form.dataset.smartCaptchaVerified === 'true') {
		return;
	}

	event.preventDefault();
	event.stopImmediatePropagation();

	if (captcha.dataset.executing === 'true') {
		return;
	}

	captcha.dataset.executing = 'true';
	form._smartCaptchaSubmitter = event.submitter;
	executeCaptcha(captcha);
}, true);

// Токен одноразовый: после AJAX-ответа виджет должен быть готов к следующей отправке.
$(document).on('submit-success submit-error', '[data-vgformsender]', function () {
	resetCaptcha(this);
});

document.addEventListener('show.bs.modal', (event) => init(event.target));
document.addEventListener('DOMContentLoaded', () => init());
